export default __webpack_public_path__ + "static/media/check.305e4d89.svg";